
export const BuyerNotificationQuery = new TypedDocumentString(`
    query BuyerNotificationQuery($input: InputId!) {
  buyerNotification(input: $input) {
    ...BuyerNotifyDoc
    __typename
  }
}
    fragment BuyerNotifyDoc on BuyerNotifyDoc {
  id
  productId
  isActive
  type
  onPriceDrop
  __typename
}`, {"hash":"12b43ac2afcf27efa5da18a1fec202a83a6bbc87664631a8a0342d936ed0b76e"});